import React, {
  useState,
  useEffect,
  ChangeEvent,
  ReactText,
  FormEvent,
} from 'react';
import { useLocation } from 'react-router-dom';
import TMSLoginReason from './view';
import { isFormValid } from './helpers/isFormValid';
import { getQueryParamValue, getSubdomainFromQuery } from '../../lib/helpers';
import { redirectUser } from '../../lib/tmsLoginReason';
import { LoadingOverlay } from 'elmo-elements';

export type ITMSLoginReasonState = {
  selectedOption: string;
  otherText: string;
  error: string;
};

export const otherOptionValue = 'other';

const tmsRedirectParam = 'redirectTo';

export const TMSLoginReasonContainer: React.FC = () => {
  const initialFormData: ITMSLoginReasonState = {
    selectedOption: '',
    otherText: '',
    error: '',
  };
  const [loading, setLoading] = useState<boolean>(false);
  const [formData, setFormData] =
    useState<ITMSLoginReasonState>(initialFormData);
  const [submitEnabled, setSubmitEnabled] = useState(true);
  const [formError, setFormError] = useState('');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [subdomain, setSubdomain] = useState('');

  useEffect(() => {
    try {
      setSubmitEnabled(isFormValid(formData));
      setFormError('');
    } catch (err) {
      setSubmitEnabled(false);
      setFormError((err as Error).message);
    }
  }, [formData]);

  const { search } = useLocation();
  const tmsRedirectPath = getQueryParamValue(tmsRedirectParam, search);

  //redirect user to home page if redirect path is not provided
  if (!tmsRedirectPath) {
    window.location.href = '/';
  }

  useEffect(() => {
    setSubdomain((oldValue: string) => {
      const newValue = getSubdomainFromQuery(tmsRedirectPath);

      return newValue;
    });
  }, [tmsRedirectPath]);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setLoading(true);
    const actionDetails = {
      site: tmsRedirectPath,
      reason: formData.otherText ? formData.otherText : formData.selectedOption,
    };

    try {
      const redirectPath = await redirectUser(actionDetails);
      setLoading(false);
      window.location.href = redirectPath;
    } catch (e) {
      setLoading(false);
      setSubmitEnabled(false);
      setFormError((e as Error).message);
    }
  };

  const handleSelect = (value: ReactText) => {
    setFormData({ ...formData, selectedOption: value as string });
  };

  return (
    <LoadingOverlay isLoading={loading} showSpinner={loading}>
      <TMSLoginReason
        handleSubmit={handleSubmit}
        handleSelect={handleSelect}
        handleTextChange={(event: ChangeEvent<HTMLInputElement>) => {
          setFormData({ ...formData, otherText: event.target.value });
        }}
        isTextAreaDisplayed={formData.selectedOption === otherOptionValue}
        submitEnabled={submitEnabled}
        otherText={formData.otherText}
        error={formError}
      />
    </LoadingOverlay>
  );
};

export default TMSLoginReasonContainer;
